import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getUserCalendarStartsSunday = (
    state: IApplicationState
): boolean => {
    const { meta, country } = getAuthUser(state);
    return !meta || meta.isCalendarStartSunday === undefined ? country === 'US' : meta.isCalendarStartSunday;
};
